import React from 'react';
import PropTypes from 'prop-types';

import SaveButton from './SaveButton';

export const SaveFileButton = props => (
  <SaveButton
    href={props.url}
    download={props.title}
    target="_blank"
    rel="noopener"
    aria-label="Скачать"
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="32" viewBox="0 0 48 32">
      <g fill="none" fillRule="evenodd">
        <path fill="#544A4C" fillRule="nonzero" d="M2.564 0h42.872c.892 0 1.215.093 1.54.267.327.174.583.43.757.756.174.326.267.65.267 1.54v26.873c0 .892-.093 1.215-.267 1.54a1.81 1.81 0 0 1-.756.757c-.326.174-.65.267-1.54.267H2.563c-.892 0-1.215-.093-1.54-.267a1.817 1.817 0 0 1-.757-.756C.093 30.65 0 30.327 0 29.437V2.563c0-.892.093-1.215.267-1.54a1.81 1.81 0 0 1 .756-.757C1.35.093 1.673 0 2.563 0z" />
        <path fill="#FFF" d="M32.25 19h3v6.724c0 .834-1.06 1.51-1.896 1.51H14.629c-.837 0-1.879-.676-1.879-1.51V19h3v5.25h16.5V19zm-9-.75l-3.858-4.904s-.605-1.096.108-1.096h2.25V5.5s.192-.75.75-.75h3c.402 0 .75.75.75.75v6.75h2.25c.866 0 .129.968.129.968s-3.366 4.52-3.879 5.032c-.75.75-1.5 0-1.5 0z" />
      </g>
    </svg>
  </SaveButton>
);

SaveFileButton.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
};

SaveFileButton.defaultProps = {
  url: '',
  title: '',
};

export default SaveFileButton;
